import { render, staticRenderFns } from "./MerchantAccounts.vue?vue&type=template&id=0585a382&"
import script from "./MerchantAccounts.vue?vue&type=script&lang=js&"
export * from "./MerchantAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports